export default {
  title: 'Sconto contratto annuale',
  buttons: {
    edit: 'Modifica sconto',
    save: 'Salva sconto',
  },
  toasts: {
    invalid_discount: 'Lo sconto per contratto annuale deve essere compreso tra {{min}}% e {{max}}%',
  },
};
